const commonList = {
  data() {
    return {
      _name: '',
      loading: true,
      selectedId: null,
      objectType: 'items',
      page: 1,
      pageSize: 25,
      dense: false,
      sortBy: [''],
      sortDesc: [false]
    }
  },
  computed: {
    listProps() {
      return {items: this.filteredList,
              headers: this.activeHeaders,
              fixedHeader: true,
              dense: this.dense,
              loading: this.loading,
              calculateWidths: true,
              height: 'calc(100vh - 212px)',
              footerProps: {itemsPerPageText:`${this.objectType.charAt(0).toUpperCase()+this.objectType.slice(1)} per page`, showFirstLastPage:true, itemsPerPageOptions:[25,50,100,-1]},
              itemClass: item => item.id === this.selectedId ? (this.$vuetify.breakpoint.mobile ? 'selected-list-item-mobile':'selected-list-item') : '',
              page: this.page,
              itemsPerPage: this.pageSize,
              noDataText: `No ${this.objectType} found`,
              loadingText: `Loading ${this.objectType}`,
              mobileBreakpoint: this.$vuetify.breakpoint.mobileBreakpoint
            };
    },
    filteredList() {
      return [];
    },
    activeHeaders() {
      const headers = this.$refs.table?.showExpand ? [{ text: '', value: 'data-table-expand', width:'5%',sortable:false,print:false}] : [];
      this.columns.forEach(column => {
        if (column.visible && this.includeColumn(column))
          headers.push(this.headers.find(header => header.value === column.value));
      });
      headers.push({ text: '' , value:'action', width:'5%',sortable:false,align:'center',print:false});
      return headers;
    }
  },
  watch: {
    pageSize() {
      localStorage.setItem(`${this.$data._name}.pageSize`, this.pageSize);
    },
    sortBy() {
      localStorage.setItem(`${this.$data._name}.sortBy`, this.sortBy[0] || '');
    },
    sortDesc() {
      localStorage.setItem(`${this.$data._name}.sortDesc`, this.sortDesc[0]?'1':'0');
    },
    filters: {
      handler() {
        if (Object.entries(this.filters).some(e => this.$route.query[e[0]] != e[1])) {
          this.totals();
          this.$router.replace({query: this.filters});
        }
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    this.pageSize = parseInt(localStorage.getItem(`${this.$data._name}.pageSize`) || 25);
    this.sortBy[0] = localStorage.getItem(`${this.$data._name}.sortBy`);
    this.sortDesc[0] = localStorage.getItem(`${this.$data._name}.sortDesc`) === '1';
    Object.entries(this.$route.query).forEach(q => this.filters[q[0]] = q[1] || this.filters[q[0]]);
    this.selectedId = await this.$store.dispatch('popSelectedId');
  },
  methods: {
    includeColumn(column) {
      return true;
    },
    totals() {
    },
    restoreSelectedItem() {
      // Make sure selected item is in view
      this.$nextTick(() => {
        let index = this.filteredList.findIndex(item => item.id === this.selectedId);
        if (index > 0) {
          if (this.pageSize !== -1) {
            this.page = Math.floor(index / this.pageSize) + 1;
            index -= (this.page - 1) * this.pageSize;
          }
          this.$refs.table.$el.querySelector(`table tbody tr:nth-child(${index})`).scrollIntoView();
        }
      });
    }
  }
}

export default commonList;